// extracted by mini-css-extract-plugin
module.exports = {"container":"Sections_container__1-CJN"};